import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import StatementPreferencesModal from './StatementPreferencesModal';
import StatementPreferenceConfirmationModal from './StatementPreferenceConfirmationModal';
import StatementPreferenceUpdateModal from './StatementPreferenceUpdateModal';
import StatementPreferenceRowTemplate from './StatementPreferenceRowTemplate';
import StatementsPreferencesActionCreator from '../../actions/StatementsPreferencesActionCreator';
import StatementsPreferencesStore from '../../stores/StatementsPreferencesStore';
import HelpActionCreator from '../../actions/HelpActionCreator';
import AccountsStore from '../../stores/AccountsStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import BrowserUtils from '../../utils/BrowserUtils';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import IEPrintIssueModalComponent from './IEPrintIssueModalComponent';
import { backgroundColorMap } from '../../utils/ui-utils';
import envConfig from '../../../static/config';
import SvgIcon from '../common/SvgIcon';
import { BioCatchContext } from '../BioCatchContext';
import { DIGITAL_SERVICING_CONTEXT } from '../../config/BioCatch';

const timeOut = 3000;

class StatementPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.backClick = this.backClick.bind(this);
    this._confirmationModal = this._confirmationModal.bind(this);
    this._onChangedPreference = this._onChangedPreference.bind(this);
    this._onContinueClick = this._onContinueClick.bind(this);
    this.helpModal = this.helpModal.bind(this);
    this.modalClick = this.modalClick.bind(this);
    this._sendRequestPacket = this._sendRequestPacket.bind(this);
    this._updatePreferenceModal = this._updatePreferenceModal.bind(this);
    this.faqAnchorClick = this.faqAnchorClick.bind(this);
    this.closeActionIEPrintModal = this.closeActionIEPrintModal.bind(this);
    this.continueActionIEPrintModal =
      this.continueActionIEPrintModal.bind(this);
    this.isAnyPaperLessStatement = this.isAnyPaperLessStatement.bind(this);

    this.state = {
      showModal: false,
      showModalIEPrintIssue: false,
      showConfirmationModal: false,
      statementPreferenceData: StatementsPreferencesStore.getPreferences(),
      requestPacket: null,
      continueButton: false,
      continueButtonClick: false,
      updatePreferenceModal: false,
      setStatementPreferenceSuccess:
        StatementsPreferencesStore.setStatementPreferenceSuccess(),
      setStatementPreferenceError:
        StatementsPreferencesStore.setStatementPreferenceError(),
    };
  }

  componentWillMount() {
    AccountsStore.addChangeListener(this.onStoreChange);
    StatementsPreferencesStore.addChangeListener(this.onStoreChange);
    StatementsPreferencesActionCreator.getPreferences();
    document.body.style.backgroundColor = backgroundColorMap[envConfig.brandId];
  }

  componentWillUnmount() {
    AccountsStore.removeChangeListener(this.onStoreChange);
    StatementsPreferencesStore.removeChangeListener(this.onStoreChange);
    document.body.style.backgroundColor = '';
  }

  onStoreChange() {
    this.setState({
      statementPreferenceData: _.cloneDeep(
        StatementsPreferencesStore.getPreferences()
      ),
      setStatementPreferenceSuccess:
        StatementsPreferencesStore.setStatementPreferenceSuccess(),
      setStatementPreferenceError:
        StatementsPreferencesStore.setStatementPreferenceError(),
    });
  }

  _closeUpdatePreferenceModal() {
    this.setState({ updatePreferenceModal: false, continueButton: false });
  }

  _confirmationModal(booleanValue) {
    this.setState({ showConfirmationModal: booleanValue });
  }

  _onBackClickConfirmation() {
    const urlString = StatementsPreferencesStore.getBackPageReference();
    urlString !== '' && InternetBankingActions.navigateToWebTask(urlString);
  }

  _onChangedPreference(id, booleanValue) {
    let preferenceData = this.state.statementPreferenceData;
    let data = _.cloneDeep(StatementsPreferencesStore.getPreferences());
    preferenceData = _.map(preferenceData, (requestItem) => {
      if (requestItem.accountId === id) {
        requestItem.optOutFlag = booleanValue;
      }
      return requestItem;
    });
    if (!_.isEqual(preferenceData, data)) {
      this.setState({ requestPacket: preferenceData, continueButton: true });
    } else {
      this.setState({ continueButton: false });
    }
  }

  _onContinueClick() {
    if (this.isAnyPaperLessStatement()) {
      this.setState({ showModalIEPrintIssue: true });
    } else {
      this.setState({ continueButtonClick: true, showModal: true }, () => {});
    }
  }

  _sendRequestPacket() {
    const requestPacket = this.state.requestPacket;
    StatementsPreferencesActionCreator.setStatementPreference(requestPacket);
    this.setState({ showModal: false, updatePreferenceModal: true });
  }

  _updatePreferenceModal(booleanValue) {
    if (booleanValue) {
      setTimeout(() => {
        this.setState({ updatePreferenceModal: false, continueButton: false });
      }, timeOut);
    }
  }

  backClick() {
    if (this.state.continueButton) {
      this._confirmationModal(true);
    } else {
      this._onBackClickConfirmation();
    }
  }

  closeActionIEPrintModal() {
    this.setState({ showModalIEPrintIssue: false });
  }

  continueActionIEPrintModal() {
    this.setState(
      {
        showModalIEPrintIssue: false,
        continueButtonClick: true,
        showModal: true,
      },
      () => {}
    );
  }

  faqAnchorClick() {
    HelpActionCreator.backSetUrl(
      'WEB-STATEMENTS-PREFERENCES',
      this.props.content.prefrenceUrl
    );
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
  }

  helpModal(booleanValue) {
    this.setState(
      { showModal: booleanValue, continueButtonClick: false },
      () => {}
    );
  }

  isAnyPaperLessStatement() {
    if (BrowserUtils.isIEOrEdgeBrowser()) {
      // Check if any account has been opt out.
      return _.find(this.state.requestPacket, { optOutFlag: true });
    }
    return false;
  }

  modalClick() {
    this.helpModal(true);
  }

  render() {
    const showModal = this.state.showModal;
    const showConfirmationModal = this.state.showConfirmationModal;
    const continueButton = this.state.continueButton;
    const statementPreferenceData = this.state.statementPreferenceData;
    const continueButtonClick = this.state.continueButtonClick;
    const updatePreferenceModalState = this.state.updatePreferenceModal;
    let desktopDisplayPage;
    let mobileDisplayPage;
    let accountModal;
    let confirmationModal;
    let updatePreferenceModal;
    let displayContinueButton;

    let modalIEPrint = (
      <IEPrintIssueModalComponent
        content={this.props.content}
        showModal={this.state.showModalIEPrintIssue}
        closeAction={this.closeActionIEPrintModal}
        continueAction={this.continueActionIEPrintModal}
        fromPrint={false}
      />
    );

    if (continueButton) {
      displayContinueButton = (
        <button className="btn selected" onClick={this._onContinueClick}>
          {this.props.content.statementContinue}
        </button>
      );
    }

    if (showModal) {
      accountModal = (
        <StatementPreferencesModal
          {...this.props}
          continueButtonClick={continueButtonClick}
          helpModal={this.helpModal}
          _sendRequestPacket={this._sendRequestPacket}
          faqAnchorClick={this.faqAnchorClick}
        />
      );
    }
    if (showConfirmationModal) {
      confirmationModal = (
        <StatementPreferenceConfirmationModal
          {...this.props}
          _confirmationModal={this._confirmationModal}
          _onBackClickConfirmation={this._onBackClickConfirmation}
        />
      );
    }
    if (updatePreferenceModalState) {
      updatePreferenceModal = (
        <StatementPreferenceUpdateModal
          {...this.props}
          setStatementPreferenceSuccess={
            this.state.setStatementPreferenceSuccess
          }
          setStatementPreferenceError={this.state.setStatementPreferenceError}
          _updatePreferenceModal={this._updatePreferenceModal}
          _closeUpdatePreferenceModal={this._closeUpdatePreferenceModal}
        />
      );
    }
    const statementPreferenceRows = statementPreferenceData.map(
      (item, index) => {
        return (
          <StatementPreferenceRowTemplate
            rowData={item}
            _onChangedPreference={this._onChangedPreference}
            key={`StatementPreferences_statementPreferenceRows_StatementPreferenceRowTemplate_${index}`}
            {...this.props}
          />
        );
      }
    );
    const deviceinfo = (
      <p className="type--uist">
        {this.props.content.statementPreferenceGotAccountInfo1}{' '}
        <a href="javascript:;" onClick={this.faqAnchorClick}>
          {this.props.content.statementPreferenceGotAccountInfoLink1}
        </a>
      </p>
    );
    if (!BrowserUtils.isMobileView()) {
      desktopDisplayPage = (
        <div>
          <Helmet title="Digital Statements" />
          <div className="main-container page account-1 financial-stories2 ">
            <div className="fc-main-wrapper digital-statement preferences">
              <div className="row statement-header">
                <div className="col-sm-6 col-xs-6 text-left">
                  <button className="page-back white" onClick={this.backClick}>
                    <span className="icon icon-page-back" />
                    {StatementsPreferencesStore.getBackPageReference() ===
                    'WEB-HOMEPAGE'
                      ? this.props.content.backToAccounts
                      : this.props.content.back}
                  </button>
                </div>
                <div className="col-sm-6 col-xs-6 text-right">
                  <button
                    className="btn-link white help-btn"
                    onClick={this.modalClick}
                  >
                    <span className="icon icon-help-questions" />
                  </button>
                </div>
              </div>
              <div className="preference-summary">
                <div className="preference-details">
                  <h3>{this.props.content.statementPreferenceHeading}</h3>
                  <p>
                    {this.props.content.goPaperfreeLine1}
                    <br />
                    {this.props.content.goPaperfreeLine2}
                    <br />
                    {this.props.content.goPaperfreeLine3}
                  </p>
                </div>
                <div className="print-settings">{statementPreferenceRows}</div>
                <div className="preference-details">
                  <h5>
                    {this.props.content.statementPreferenceGotAccountHeader}
                  </h5>
                  <p>
                    {this.props.content.statementPreferenceGotAccountBody1}
                    <br />
                    {this.props.content.statementPreferenceGotAccountBody2}
                  </p>
                  {deviceinfo}
                </div>
                <div className="continue-btn">{displayContinueButton}</div>

                <p className="back_to_head">
                  <a href="javascript:void(0)" onClick={this.backToTop}>
                    <span className="back-to-top-icon">
                      <SvgIcon id="icon-up" width="24px" height="24px" />
                    </span>
                  </a>
                </p>
              </div>
              {updatePreferenceModal}
            </div>
            {modalIEPrint}
            {accountModal}
            {confirmationModal}
          </div>
        </div>
      );
    } else {
      if (showModal) {
        mobileDisplayPage = (
          <StatementPreferencesModal
            {...this.props}
            continueButtonClick={continueButtonClick}
            helpModal={this.helpModal}
            _sendRequestPacket={this._sendRequestPacket}
            faqAnchorClick={this.faqAnchorClick}
          />
        );
      } else {
        mobileDisplayPage = (
          <div className="account-1 financial-stories2 main-container">
            <div className="fc-main-wrapper digital-statement preferences">
              <div className="row no-gutters statement-header">
                <div className="col-sm-6 col-xs-6 text-left">
                  <button className="page-back white" onClick={this.backClick}>
                    <span className="icon icon-page-back" />
                    {StatementsPreferencesStore.getBackPageReference() ===
                    'WEB-HOMEPAGE'
                      ? this.props.content.backToAccounts
                      : this.props.content.back}
                  </button>
                </div>
                <div className="col-sm-6 col-xs-6 text-right">
                  <button
                    className="btn-link white help-btn"
                    onClick={this.modalClick}
                  >
                    <span className="icon icon-help-questions" />
                  </button>
                </div>
              </div>
              <div className="preference-summary">
                <div className="preference-details">
                  <h4>{this.props.content.statementPreferenceHeading}</h4>
                  <p>
                    {this.props.content.goPaperfreeLine1}
                    <br />
                    {this.props.content.goPaperfreeLine2}
                    <br />
                    {this.props.content.goPaperfreeLine3}
                  </p>
                </div>
                <div className="print-settings">{statementPreferenceRows}</div>
                <div className="preference-details">
                  <h5>
                    {this.props.content.statementPreferenceGotAccountHeader}
                  </h5>
                  <p>
                    {this.props.content.statementPreferenceGotAccountBody1}
                    <br />
                    {this.props.content.statementPreferenceGotAccountBody2}
                  </p>
                  {deviceinfo}
                </div>
                <div className="continue-btn">{displayContinueButton}</div>
              </div>
              {modalIEPrint}
              {confirmationModal}
              {updatePreferenceModal}
            </div>
          </div>
        );
      }
    }
    return (
      <BioCatchContext context={DIGITAL_SERVICING_CONTEXT}>
        <div className="b container-fluid-full scrollable">
          {BrowserUtils.isMobileView() ? mobileDisplayPage : desktopDisplayPage}
        </div>
      </BioCatchContext>
    );
  }
}

StatementPreferences.propTypes = {
  content: PropTypes.object,
  onMicroTileClick: PropTypes.func,
  statementPreferenceData: PropTypes.object,
  statementPreferenceDataObject: PropTypes.object,
  setStatementPreferenceError: PropTypes.bool,
  setStatementPreferenceSuccess: PropTypes.bool,
};

export default RequiresAuthenticatedUser(StatementPreferences);
